import logo from './logo.svg';
import './App.css';




import PrivateOrCompany from './components/forms/vhf/PrivateOrCompany';
import PrivateContact from './components/forms/vhf/private/PrivateContact';
import  Header from './components/layout/headerNew/Header'
import  Footer from './components/layout/footerNew/Footer'


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ShipInfo from './components/forms/vhf/eq/ShipInfo';
import Preview from './components/forms/vhf/preview/Preview';
import * as VhfLang from "./components/forms/vhf/VhfLang";
import CompanyContact from './components/forms/vhf/company/CompanyContact';
import {
  Container 
} from "react-bootstrap";
import Thanks from './components/forms/vhf/thanks/Thanks';


function App() {

 
  return (
<>

    {/* <div className="App">
    <Header/>      

<Container  className="my-1">

<Router> */}
    <Router>
<div className="d-flex flex-column h-100" style={{ minHeight: '100vh' }}>
<Header/>
       <Container fluid="sm" style={{ maxWidth: '860px', marginBottom: '36px' }}>
    <Routes>
    
    <Route path={VhfLang.NavStartPage} excat element={<PrivateOrCompany /> } />
    <Route path={VhfLang.NavPrivateContactInfo} excat element={<PrivateContact/> } />
    <Route path={VhfLang.NavCompanyContactInfo} excat element={<CompanyContact/> } />
    <Route path={VhfLang.NavShipInfo} excat element={<ShipInfo/> } />
    <Route path={VhfLang.NavPreview} excat element={<Preview/> } />
    <Route path={VhfLang.NavThanks} excat element={<Thanks/> } />
    <Route path={"/"} excat element={<PrivateOrCompany /> } />
  </Routes>

       </Container>
  <Footer />

      
    </div>
 </Router> 
  
   
  {/* </Router>
  
  </Container>



    </div>
    <Footer/> */}
    </>
  );
}

export default App;


/*<Route path="vhf" excat element={<Step1Vhf/> } 
/>
<Route path="/vhf/preview" excat element={<Preview/> } />*/

